<template>
    <div>
        <table class="table">
            <tr>
                <th>attendance</th>
                <th>referee</th>
                <th>referee_assistants</th>
                <th>weather_info</th>
            </tr>
            <tr>
                <td>{{ sport_event_conditions.attendance }}</td>
                <td>
                    <div v-if="sport_event_conditions.referee">
                        name: {{ sport_event_conditions.referee.name }}<br>
                        id: {{ sport_event_conditions.referee.id }}<br>
                        nationality: {{ sport_event_conditions.referee.nationality }}<br>
                        country_code: {{ sport_event_conditions.referee.country_code }}
                    </div>
                </td>
                <td>
                    <div v-for="referee_assistant in sport_event_conditions.referee_assistants" style="margin-bottom:10px;">
                        name: {{ referee_assistant.name }}<br>
                        id: {{ referee_assistant.id }}<br>
                        type: {{ referee_assistant.type }}<br>
                        nationality: {{ referee_assistant.nationality }}<br>
                        country_code: {{ referee_assistant.country_code }}
                    </div>
                </td>
                <td>
                    <div v-if="sport_event_conditions.weather_info">
                        pitch: {{ sport_event_conditions.weather_info.pitch }}<br>
                        weather_conditions: {{ sport_event_conditions.weather_info.weather_conditions }}<br>
                    </div>
                </td>
            </tr>
        </table>
    </div>
    
</template>

<script>
export default {
    name: 'SoccerScoresConditions',
    props: {
        sport_event_conditions: ''
    }
}
</script>

